import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import auth from "../../services/authService";
import { Link } from "react-router-dom";
import pesonalinfoIcon from "../../assets/images/general/pesonalinfo.svg";
//import devicesIcon from "../../assets/images/general/devices.svg";
import certificatIcon from "../../assets/images/general/certificat.svg";
import ComplaintIcon from "../../assets/images/general/Complaint.svg";
import UserProfileInfo from "./userProfileInfo";
export default function ProfileNav() {

    const [show, setShow] = useState(false);
    const user = auth.getCurrentUser();
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const customersClub = 1;
    const certificates = 2;
    

    return (
        <>
            <div className="container ">
                <div className="row profilenav hrow">
                    <a className="col-5 d-flex justify-content-center align-items-center companyname">{user.unique_name}</a>
                    <ul className="col-7 d-flex justify-content-center nav ">
                        <li className="col-3 nav-item">
                            {/*<Link className="nav-link" to="/userinfo">*/}
                            <Link className="nav-link" to={`/underConstruction/${customersClub}`} >
                                <img src={pesonalinfoIcon} alt="" />
                            </Link>
                        </li>
                        {/*<li className="col-3 nav-item">*/}
                        {/*    <Link className="nav-link" to="#">*/}
                        {/*        <img src={devicesIcon} alt="" />*/}
                        {/*    </Link>*/}
                        {/*</li>*/}
                        <li className="col-3 nav-item">
                            <Link className="nav-link" to={`/underConstruction/${certificates}`} >
                            {/*<Link className="nav-link" to="/certificate" state={{ title: user.unique_name }} >*/}
                                <img src={certificatIcon} alt="" />
                            </Link>
                        </li>
                        <li className="col-3 nav-item">
                            <Link className="nav-link " to="/complaint">
                                <img src={ComplaintIcon} alt="" />
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>اطلاعات کاربر</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserProfileInfo />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        بستن
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
